function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// eslint-disable-next-line no-shadow
export var ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["SET_NAVIGATION_ACTIVE"] = "setNavigationActive";
  ActionType["SET_NAVIGATION_INACTIVE"] = "setNavigationInactive";
  ActionType["SET_NAVIGATION_LIST_FOCUS"] = "setNavigationListFocus";
  return ActionType;
}({});
export default function mainReducer(state, action) {
  switch (action.type) {
    case ActionType.SET_NAVIGATION_ACTIVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isNavigationActive: true,
        navigationIndex: action.navigationIndex,
        markerLeftPosition: action.markerLeftPosition,
        desktopDropdown: action.desktopDropdown
      });
    case ActionType.SET_NAVIGATION_INACTIVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isNavigationActive: false,
        navigationIndex: null,
        markerLeftPosition: null,
        desktopDropdown: null,
        navigationListFocusIndex: null
      });
    case ActionType.SET_NAVIGATION_LIST_FOCUS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isNavigationActive: action.isHugeScreen ? false : state.isNavigationActive,
        navigationIndex: null,
        markerLeftPosition: null,
        desktopDropdown: null,
        navigationListFocusIndex: action.navigationListFocusIndex
      });
    default:
      return state;
  }
}
export var initialState = {
  isNavigationActive: false,
  navigationIndex: null,
  markerLeftPosition: null,
  desktopDropdown: null,
  navigationListFocusIndex: null
};